<template>
  <div class="main-container mb-8 w-100">
    <div class="editor-container_classic-editor">
      <div class="editor-container__editor rich-text-editor">
        <div
          class="text-title-medium text-font"
        >
          {{ label }}
        </div>
        <html-editor
          v-model="text"
        />
        <div
          v-if="hint"
          class="text-label text-font text-body-small"
        >
          {{ hint }}
        </div>
      </div>
      <div
        v-if="error"
        class="text-label text-error"
      >
        <div
          v-for="message in errorMessages"
          :key="message"
        >
          {{ message }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import HtmlEditor from './HtmlEditor.vue';

defineProps<{
  error?: boolean;
  errorMessages?: string[];
  label: string;
  hint?: string;
}>();

const text = defineModel<string>();
</script>
